// extracted by mini-css-extract-plugin
export var buttonInMenu = "newsletter-module--button-in-menu--ydwX+";
export var fixedWrapper = "newsletter-module--fixed-wrapper--7VGE-";
export var footerWrapper = "newsletter-module--footer-wrapper--IHRzh";
export var layoutWrapper = "newsletter-module--layout-wrapper--TG-3q";
export var menuBurger = "newsletter-module--menu-burger--aj07k";
export var navigationWrapper = "newsletter-module--navigation-wrapper--Ezk2Q";
export var title = "newsletter-module--title--wIihC";